// 1 bottle 75cl is Xkg (1.5L equal 2 bottles)
export const calculateBottleWeightKg = (quantity: number, volume: number): number => {
  return ((volume * quantity) / 0.75) * 1.3;
};

export const calculateDeliveryContentMinimumWeightKg = (
  deliveryContent: { numberOfBottles: number; volume: number }[],
): number => {
  return deliveryContent.reduce(
    (sum, item) => sum + calculateBottleWeightKg(item.numberOfBottles ?? 0, item.volume ?? 0),
    0,
  );
};

export const calculateExpeditionPackagingTotalWeightKg = (
  expeditionPackaging: { weight: number; count: number }[],
): number => {
  return expeditionPackaging.reduce((sum, pkg) => sum + (pkg.weight ?? 0) * (pkg.count ?? 0), 0);
};
